/**
 * Observações do produto x linhas de cotação (decisão de 2026-10-07):
 *
 *  - No SANKHYA (AD_OBSINT) fica SOMENTE o que foi escrito à mão.
 *  - No AEROSYS (APE_OBS) o backend monta o texto: as linhas de cotação
 *    "<fornecedor>   <data>   <moeda> <preço>" (3 espaços entre as partes, a mais
 *    nova primeiro e as anteriores mantidas logo abaixo), uma linha em branco e,
 *    por fim, o texto escrito à mão (ver ProdutoAerosysComponent#montarObservacaoAerosys).
 *
 * Por isso o frontend nunca mais grava a linha de cotação na observação: aqui só
 * existe a função que LIMPA essas linhas de textos antigos (produtos salvos antes
 * dessa mudança, ou copiados de um modelo antigo), devolvendo só o texto manual.
 */
export function removerLinhasCotacao(texto: string | null | undefined): string {
    if (!texto) return '';
    const linhas = texto.replace(/\r/g, '').split('\n');
    let i = 0;
    while (i < linhas.length) {
        const l = linhas[i].trim();
        if (l === '' || ehLinhaCotacao(l)) {
            i++;
            continue;
        }
        break;
    }
    return linhas.slice(i).join('\n').trim();
}

/** "<fornecedor> <data> U$|R$ <preço>" (1 ou mais espaços) ou o rótulo antigo "Cotação Realizada Em: ...". */
function ehLinhaCotacao(linha: string): boolean {
    return /^Cota[cç][aã]o Realizada Em:/i.test(linha)
        || /^\S.*\s\d{2}\/\d{2}\/\d{4}\s+[UR]\$\s*[\d.,]+\s*$/i.test(linha);
}
